import React from "react";
import toast from "react-hot-toast";
import Loading from "../../Common/Loading";
const Mobile = ({ landingLoading }) => {
  const LinkApp = [
    {
      image: window.origin + "/WebSide/assets/images/bazzar.png",
      url: "https://cafebazaar.ir/app/ir.nikotani",
    },
    {
      image: window.origin + "/WebSide/assets/images/google-play.png",
      url: "",
    },
    {
      image: window.origin + "/WebSide/assets/images/myket.png",
      url: "https://myket.ir/app/ir.nikotani",
    },
  ];
  if (landingLoading) {
    return (
      <section className="background-gray">
        <div className="container">
          <div className="row align-items-center">
            <Loading count={1} col={12} height={500} />
          </div>
        </div>
      </section>
    );
  }
  return (
    <>
      <section className="background-gray">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 py-4">
              <div className="d-flex">
                <img
                  style={{
                    width: "65px",
                    objectFit: "contain",
                    height: "65px",
                  }}
                  src={window.origin + "/WebSide/assets/images/app-icon.png"}
                  alt="nikotan | نیکوتن"
                />
                <div className="ms-2">
                  <h4
                    style={{
                      color: "#0f0f0f",
                    }}
                    className="  "
                  >
                    دانلود اپلیکیشن نیکوتن
                  </h4>
                  <p
                    className="mt-2"
                    style={{
                      color: "#404040",
                      fontWeight: "400",
                    }}
                  >
                    با اپلیکیشن نیکوتن راحت تر می توانید مجموعه های ورزشی <br />
                    اطراف خود را پیدا کنید و آن ها را رزرو کنید.
                  </p>
                </div>
              </div>

              <div className="d-flex flex-column ">
                <div className="mt-md-5">
                  <div className="row justify-content-center">
                    {/* <a href={window.origin + "/app.apk"}>
                    <i
                      style={{ color: "#555555" }}
                      className="fas fa-file-download"
                    ></i>
                    <span style={{ marginRight: "3px", color: "#555555" }}>
                      {" "}
                      دانلود با لینک مستقیم
                    </span>
                  </a> */}
                    <div className="col-12 mt-4">
                      <div className="d-flex align-items-center flex-wrap">
                        {LinkApp.map((linkapp, i) => {
                          return (
                            <button
                              key={i}
                              className="mb-2"
                              style={{
                                border: "none",
                                backgroundColor: "transparent",
                                minWidth: "110px",
                                maxWidth: "130px",
                              }}
                              target={linkapp.url === "" ? "" : "_blank"}
                              href={
                                linkapp.url === "" ? undefined : linkapp.url
                              }
                              onClick={() =>
                                linkapp.url === ""
                                  ? toast.success(
                                      "به زودی در دسترس قرار میگیرد"
                                    )
                                  : window.open(
                                      linkapp.url,
                                      "_blank",
                                      "noopener,noreferrer"
                                    )
                              }
                            >
                              <img
                                width={"100%"}
                                src={linkapp.image}
                                alt="nikotan | نیکوتن"
                              />
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-none d-md-block">
              <div className="w-100">
                <img
                  style={{
                    width: "100%",
                    objectFit: "contain",
                    maxHeight: "400px",
                  }}
                  src={window.origin + "/WebSide/assets/images/mockup.png"}
                  alt="nikotan | نیکوتن"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Mobile;
